<div class="container mt-5">
  <div class="card">
    <div class="card-header text-white text-center">
      <h2>COntactos</h2>
    </div>
    <br>
    <form>
      <div class="mb-3 row align-items-center">
        <label
          for="table-filtering-search"
          class="col-xs-3 col-sm-auto col-form-label custom-label"
        >
          Full text search:
        </label>
        <div class="col-xs-3 col-sm-auto">
          <input
            id="table-filtering-search"
            class="form-control"
            type="text"
            [formControl]="filter"
            style="height: 30px;"
          />
        </div>
      </div>
    </form>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Email</th>
          <th scope="col">ID de estudiante</th>
          <th scope="col">Status</th>
          <th scope="col">Fecha de seguimiento</th>
        </tr>
      </thead>
      <tbody>
        @for (contact of pagedContacts; track contact._id) {
          <tr>
            <td>
              <ngb-highlight
                [result]="contact.contactMail"
                [term]="filter.value"
              ></ngb-highlight>
            </td>
            <td>
              <ngb-highlight
                [result]="contact.associatedStudentID"
                [term]="filter.value"
              ></ngb-highlight>
            </td>
            <td>
              <ngb-highlight
                [result]="contact.status"
                [term]="filter.value"
              ></ngb-highlight>
            </td>

            <td>
              <ngb-highlight
                [result]="contact.followupDate | date"
                [term]="filter.value"
              ></ngb-highlight>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="4" style="text-align: center">No hay contactos o no se pudieron cargar</td>
          </tr>
        }
      </tbody>
    </table>

    <app-pagination
      [(page)]="page"
      [totalItems]="filteredContacts.length"
      [pageSize]="pageSize"
    ></app-pagination>
  </div>
</div>
